
// eslint-disable-next-line import/no-cycle
import Router from '@/router';

export default {
  name: 'FoodView',
  metaInfo: {
    title: 'Food Artwork',
  },
  computed: {
    rootPath() {
      return '/food';
    },
    recommend() {
      return `${this.rootPath}/recommend`;
    },
    promotion() {
      return `${this.rootPath}/promotion`;
    },
    sales() {
      return `${this.rootPath}/sales`;
    },
    discount() {
      return `${this.rootPath}/discount`;
    },
    shoplove() {
      return `${this.rootPath}/shoplove`;
    },
    prodd() {
      return `${this.rootPath}/prodd`;
    },
  },
  methods: {
    routeToView(viewName: string) {
      Router.push(viewName);
    },
  },
};
